module.exports = __webpack_public_path__ + "assets/images/000652a7fcb61c3dd15be6e09f8d6fe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/ansell/ansell-1.jpg
// module id = 814
// module chunks = 0